import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { DefectRef } from '../../models/defect-ref.model';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-defect-ref-chips',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, MatTooltip, RouterLink, TranslatePipe],
  templateUrl: './defect-ref-chips.component.html',
  styleUrl: './defect-ref-chips.component.scss',
})
export class DefectRefChipsComponent {
  readonly projectId = input.required<string>();
  readonly defects = input.required<DefectRef[]>();
  readonly compact = input(false);
}
